import { render, staticRenderFns } from "./iowater.vue?vue&type=template&id=79385f18&scoped=true&"
import script from "./iowater.vue?vue&type=script&lang=js&"
export * from "./iowater.vue?vue&type=script&lang=js&"
import style0 from "./iowater.vue?vue&type=style&index=0&id=79385f18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79385f18",
  null
  
)

export default component.exports